/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DailyReward
 */
export interface DailyReward {
  /**
   *
   * @type {number}
   * @memberof DailyReward
   */
  farmed?: number
  /**
   *
   * @type {number}
   * @memberof DailyReward
   */
  staked?: number
  /**
   *
   * @type {number}
   * @memberof DailyReward
   */
  holderBonuses?: number
  /**
   *
   * @type {number}
   * @memberof DailyReward
   */
  cashback?: number
  /**
   *
   * @type {number}
   * @memberof DailyReward
   */
  referralRewards?: number
}

export function DailyRewardFromJSON(json: any): DailyReward {
  return DailyRewardFromJSONTyped(json, false)
}

export function DailyRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyReward {
  if (json === undefined || json === null) {
    return json
  }
  return {
    farmed: !exists(json, 'farmed') ? undefined : json['farmed'],
    staked: !exists(json, 'staked') ? undefined : json['staked'],
    holderBonuses: !exists(json, 'holderBonuses') ? undefined : json['holderBonuses'],
    cashback: !exists(json, 'cashback') ? undefined : json['cashback'],
    referralRewards: !exists(json, 'referralRewards') ? undefined : json['referralRewards'],
  }
}

export function DailyRewardToJSON(value?: DailyReward | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    farmed: value.farmed,
    staked: value.staked,
    holderBonuses: value.holderBonuses,
    cashback: value.cashback,
    referralRewards: value.referralRewards,
  }
}
